var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGadgetDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 118,
    viewBox: "0 0 69 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.808 0.795227H5.77406C3.40138 0.795227 1.47852 2.62845 1.47852 4.88984V112.464C1.47852 114.725 3.40138 116.559 5.77406 116.559H63.808C66.1807 116.559 68.1036 114.725 68.1036 112.464V4.88984C68.1036 2.62845 66.1807 0.795227 63.808 0.795227Z",
    fill: "#131111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.87238,
    width: 58,
    height: 108,
    rx: 4,
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.808 117.127H5.77404C3.07676 117.127 0.881836 115.036 0.881836 112.464V4.88981C0.881836 2.31774 3.07676 0.226379 5.77404 0.226379H63.808C66.5053 0.226379 68.7002 2.31774 68.7002 4.88981V112.464C68.7002 115.036 66.5053 117.127 63.808 117.127ZM5.77404 1.36557C3.73523 1.36557 2.07668 2.94684 2.07668 4.88981V112.464C2.07668 114.407 3.73523 115.988 5.77404 115.988H63.808C65.8468 115.988 67.5054 114.407 67.5054 112.464V4.88981C67.5054 2.94684 65.8468 1.36557 63.808 1.36557H5.77404Z",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7923 9.51748C33.8617 9.51748 33.1074 8.79873 33.1074 7.91148C33.1074 7.02424 33.8617 6.30548 34.7923 6.30548C35.7228 6.30548 36.4771 7.02424 36.4771 7.91148C36.4771 8.79873 35.7228 9.51748 34.7923 9.51748Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadgetDarkIcon);
export default __webpack_public_path__ + "static/media/gadget-dark-icon.9d9ee0609e2566d620f007b91e0c3ed9.svg";
export { ForwardRef as ReactComponent };